module.exports = __webpack_public_path__ + "img/logo-geekbang-tgo.508d8d82.png";